"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = exports.defaultState = exports.defaultIdKeys = exports.defaultHeaders = exports.defaultActions = exports.defaultGlobals = void 0;

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/* global fetch */


var defaultActions = {
  create: {
    method: 'POST'
  },
  fetch: {
    method: 'GET',
    isArray: true
  },
  get: {
    method: 'GET'
  },
  update: {
    method: 'PATCH'
  },
  updateMany: {
    method: 'PATCH',
    isArray: true,
    alias: 'update'
  },
  delete: {
    method: 'DELETE'
  },
  deleteMany: {
    method: 'DELETE',
    isArray: true,
    alias: 'delete'
  }
};
exports.defaultActions = defaultActions;
var defaultHeaders = {
  Accept: 'application/json',
  'Content-Type': 'application/json'
};
exports.defaultHeaders = defaultHeaders;
var defaultIdKeys = {
  singular: 'id',
  plural: 'ids'
};
exports.defaultIdKeys = defaultIdKeys;
var defaultState = {
  create: {
    isCreating: false
  },
  fetch: {
    items: [],
    isFetching: false,
    lastUpdated: 0,
    didInvalidate: true
  },
  get: {
    item: null,
    isFetchingItem: false,
    lastUpdatedItem: 0,
    didInvalidateItem: true
  },
  update: {
    isUpdating: false
  },
  delete: {
    isDeleting: false
  }
};
exports.defaultState = defaultState;
var initialState = Object.keys(defaultState).reduce(function (soFar, key) {
  return _objectSpread({}, soFar, defaultState[key]);
}, {});
exports.initialState = initialState;
var defaultGlobals = {
  Promise: Promise,
  fetch: fetch
};
exports.defaultGlobals = defaultGlobals;